<template>
    <QuickLinks ref="QuickLinks"></QuickLinks>
    <InterventiAssegnati></InterventiAssegnati>

</template>
<script>

import QuickLinks from "@/components/QuickLinks.vue";
import InterventiAssegnati from "@/components/InterventiAssegnati.vue";

export default {
    name: "Home",
    components:{
        QuickLinks,
        InterventiAssegnati
    }
}
</script>